import { extractApiErrorMessage } from '../../../utils/errorHandler';
import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d504Api } from '../../../services/d504Api';
import type { ItemState } from './useD504Query';

export function useD504Approval(
  items: ItemState[],
  resetItems: () => void,
  api = d504Api
) {
  const [executing, setExecuting] = useState(false);

  /** Execute approval for all selected items */
  const handleExecute = useCallback(async (): Promise<boolean> => {
    const selectedNos = items
      .filter((s) => s.selected)
      .map((s) => s.item.fd140_01);

    if (selectedNos.length === 0) {
      message.warning('請先勾選要核准的託工入庫單');
      return false;
    }

    setExecuting(true);
    try {
      const res = await api.execute(selectedNos);
      if (res.failed === 0) {
        message.success(res.message || `核准完成，成功 ${res.success} 筆`);
      } else {
        message.warning(
          res.message || `成功 ${res.success} 筆，失敗 ${res.failed} 筆`
        );
        if (res.results) {
          res.results
            .filter((r) => !r.success)
            .forEach((r) => message.error(`${r.receipt_no}: ${r.message}`));
        }
      }
      // Clear items after execution
      resetItems();
      return true;
    } catch (e: unknown) {
      message.error(extractApiErrorMessage(e, '核准執行失敗'));
      return false;
    } finally {
      setExecuting(false);
    }
  }, [api, items, resetItems]);

  return {
    executing,
    handleExecute,
  };
}
